import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import type { paymentServicesTypes } from '@makemydeal/dr-platform-types';
import { LEASE } from '@makemydeal/dr-platform-types';
import type { FC } from 'react';
import { useSelector } from 'react-redux';
import ItemizedLeaseSummary from './ItemizedLeaseSummary';
import TaxItemSummary from './TaxItemSummary';
import useDisplayTaxData from './helpers/useDisplayTaxData';

type ItemizedTaxesSummaryProps = {
    data: paymentServicesTypes.TaxItems;
    taxOverrideEnabled?: boolean;
    isTaxesFormDirtyRef?: React.MutableRefObject<boolean>;
};

const ItemizedTaxesSummary: FC<ItemizedTaxesSummaryProps> = ({ data, taxOverrideEnabled, isTaxesFormDirtyRef }) => {
    const offerType = useSelector(offerReduxSelectors.getCurrentOfferType);
    const displayData = useDisplayTaxData(data, taxOverrideEnabled);
    const isLeaseOffer = offerType === LEASE;

    return (
        <>
            {isLeaseOffer && <ItemizedLeaseSummary data={displayData} taxOverrideEnabled={taxOverrideEnabled} />}
            {!isLeaseOffer && (
                <>
                    {displayData.map((taxItem, i) => (
                        <TaxItemSummary
                            taxItem={taxItem}
                            key={taxItem.taxName + i}
                            taxOverrideEnabled={taxOverrideEnabled}
                            taxIndex={i}
                            isTaxesFormDirtyRef={isTaxesFormDirtyRef}
                        />
                    ))}
                </>
            )}
        </>
    );
};

export default ItemizedTaxesSummary;
